import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

export const getSuccessStories = async (projectId, perPage, page) => {
    return await api.get("/successStories", { projectId, perPage, page });
};

export const createSuccessStory = async (name, description, projectId) => {
    return await api.post("/successStories", { name, description, projectId });
};

export const getSuccessStory = async (successStoryId, projectId) => {
    return await api.get(`/successStories/${successStoryId}`, { projectId });
};

export const updateSuccessStory = async (successStoryId, name, description, projectId) => {
    return await api.put(`/successStories/${successStoryId}`, { name, description, projectId });
};

export const deleteSuccessStory = async (successStoryId, projectId) => {
    return await api.put(`/successStories/delete/${successStoryId}`, { projectId });
};
